
import api from "../../api";

const subAdapter = {
  location: {
    formToRequestBody(input = {}){
      let output = {}

      if(input){
        const {
          province,
          city,
          address,
          pin_point = ''
        } = input

        output = {
          provinsi: province,
          kota: city,
          jalan: address,
          pin_location: pin_point,
          /**
           * @todo Check if visibility field is still needed
           */
          type_visibility: 1
        }
      }

      return output
    },
    responseBodyToForm(input){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const lokasi = input[index];

          output.push({
            pkId: lokasi.pkLokasiActivityId,
            province: lokasi.provinsi,
            city: lokasi.kota,
            address: lokasi.jalan,
            pin_point: lokasi.pinLocation,
          })
        }
      }

      return output
    }
  },
  journey: {
    formToRequestBody(input){
      let output = {}

      if(input){
        const {
          id,
          index,
          title_id,
          title_en,
          description_id,
          description_en
        } = input

        output = {
          pkJourneyId: id,
          nomor_urut: index,
          judul_journey: [
            title_id,
            title_en
          ],
          deskripsi: [
            description_id ? description_id : 'N/A',
            description_en ? description_en : 'N/A'
          ]
        }
      }

      return output
    },
    responseBodyToForm(input){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const journey = input[index];

          output.push({
            id: journey.pkJourneyId,
            title_en: journey.judulJourney[1],
            title_id: journey.judulJourney[0],
            description_en: journey.deskripsi[1],
            description_id: journey.deskripsi[0],
            index: journey.nomorUrut,
            image: api.base_image+journey.imgThumbnailJourney
          })
        }
      }

      const sortedByIndex = output.sort((a, b) => a.index - b.index)
      return sortedByIndex
    }
  },
  gallery: {
    formToRequestBody(input = []){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const blob = input[index];
          output.push({
            deskripsiGambar: [
              `default ${blob}`,
              `default ${blob}`
            ],
            typeVisibility: 1
          })
        }
      }

      return output
    }
  },
  files: {
    formToRequestBody(input = []){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const blob = input[index];
          output.push({
            deskripsiFile: [
              `default ${blob}`,
              `default ${blob}`
            ],
            typeVisibility: 1,
            embedLink: 'https://embed.com'
          })
        }
      }

      return output
    }
  },
  milestone: {
    formToRequestBody(input){
      let output = {}

      if(input){
        const {
          index,
          status,
          description_en,
          description_id,
          files
        } = input

        const finalDescriptionId = description_id ? description_id : 'N/A'
        const finalDescriptionEn = description_en ? description_en : 'N/A'

        output = {
          // faseId: "rQWJcITg",
          nomorUrut: index,
          deskripsi: [finalDescriptionId, finalDescriptionEn],
          resources: null,
          files: files?.map(f => {
            return {
              deskripsiFile: JSON.stringify(f)
            }
          }),
          isDone: status === 'completed' ? true : false
        }
      }

      return output
    },
    responseBodyToForm(input){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const element = input[index];

          const {
            // files,
            binFaseFile,
            faseId,
            nomorUrut,
            deskripsi,
            isDone
          } = element

          const splited = binFaseFile.split('/')
          const filename = splited[splited.length-1]

          const adaptedFiles = binFaseFile === '/assets/file.pdf' ? [] : [{
            name: filename,
            file: api.base_image+binFaseFile
          }]

          output.push({
            id: faseId,
            index: nomorUrut,
            description_en: deskripsi[1],
            description_id: deskripsi[0],
            status: isDone === false ? 'incompleted' : 'completed',
            files: adaptedFiles
          })
        }
      }

      return output
    }
  },
  partner: {
    formToRequestBody(input){
      console.log('partner.formToRequestBody input:', input)
      let output = null

      if(input && input.name !== null && input.name !== 'null'){
        if(input.id && typeof input.id === 'number'){
          output = input.id
        } else {
          output = parseInt(input.name)
        }
      }

      console.log('partner.formToRequestBody output:', output)

      return output
    },
    external: {
      formToRequestBody(input){
        let output

        if(input){
          const {
            id,
            name,
            website,
            // image
          } = input

          output = {
            pkPartnerActivityEksternalId: id ? id : null,
            namaPartner: name,
            websitePartner: website,
            // imgLogoPartner: image,
          }
        }

        return output
      }
    }
  },
  survey: {
    formToRequestBody(input = []){
      let output = []

      if(input && input.length > 0){
        const filtered = input.filter(i => i.name !== undefined)
        if(filtered && filtered.length > 0){
          for (let index = 0; index < filtered.length; index++) {
            const element = filtered[index];
            const {
              name,
              category,
              baseline,
              endline,
              id
            } = element

            output.push({
              pkBaselineEndlineSurveyId: id,
              variablePerubahan: {
                kategori: category,
                nama: name ? name : 'undefined',
              },
              // variablePerubahan: 1,
              pretest: baseline || 1,
              posttest: endline || 1,
            })
          }
        }
      }

      return output
    },
    responseBodyToForm(input = []){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const s = input[index];

          output.push({
            id: s.pkBaselineEndlineSurveyId,
            name: s.variablePerubahan?.nama?.[0],
            categoryId: s.variablePerubahan?.id,
            category: s.variablePerubahan?.kategori?.[0],
            baseline: s.pretest,
            endline: s.posttest
          })
        }
      }

      return output
    }
  },
  statistic: {
    formToRequestBody(input = {}){
      let output = {}

      if(input){
        const {
          beneficiaries_gender_men = 0,
          beneficiaries_gender_women = 0,
          beneficiaries_gender_difable_men = 0,
          beneficiaries_gender_difable_women = 0,
          retention_pre_program_men = 0,
          retention_pre_program_women = 0,
          retention_post_program_men = 0,
          retention_post_program_women = 0,
          satisfaction_very_satisfied = 0,
          satisfaction_satisfied = 0,
          satisfaction_neutral = 0,
          satisfaction_disatisfied = 0,
          satisfaction_very_disatisfied = 0,
          cac = 0,
          nps_detractors = 0,
          nps_passives = 0,
          nps_promoters = 0,
          nps_1 = 0,
          nps_2 = 0,
          nps_3 = 0,
          nps_4 = 0,
          nps_5 = 0,
          nps_6 = 0,
          nps_7 = 0,
          nps_8 = 0,
          nps_9 = 0,
          nps_10 = 0,
        } = input

        output = {
          "beneficiariesMen": beneficiaries_gender_men,
          "beneficiariesWomen": beneficiaries_gender_women,
          "beneficiariesMenDifable": beneficiaries_gender_difable_men,
          "beneficiariesWomenDifable": beneficiaries_gender_difable_women,
          "retentionSaatProgramMen": retention_pre_program_men,
          "retentionSaatProgramWomen": retention_pre_program_women,
          "retentionPascaProgramMen": retention_post_program_men,
          "retentionPascaProgramWomen": retention_post_program_women,
          "satisfactionSangatTidakPuas": satisfaction_very_disatisfied,
          "satisfactionTidakPuas": satisfaction_disatisfied,
          "satisfactionNetral": satisfaction_neutral,
          "satisfactionPuas": satisfaction_satisfied,
          "satisfactionSangatPuas": satisfaction_very_satisfied,
          "customerAcquisitionScore": cac,
          "netPromotorScoreDetractors": nps_detractors,
          "netPromotorScorePassive": nps_passives,
          "netPromotorScorePromoters": nps_promoters,
          "netPromotorScore1": nps_1,
          "netPromotorScore2": nps_2,
          "netPromotorScore3": nps_3,
          "netPromotorScore4": nps_4,
          "netPromotorScore5": nps_5,
          "netPromotorScore6": nps_6,
          "netPromotorScore7": nps_7,
          "netPromotorScore8": nps_8,
          "netPromotorScore9": nps_9,
          "netPromotorScore10": nps_10,
        }
      }

      return output
    }
  }
}

export default subAdapter
